/**
 * Encore Foundation - 7.24.0
 *
 * The contents of this file is owned and generated by the Encore team.
 * If you need to make changes to the values stored here please reach out
 * to #encore on Slack.
 *
 * Links:
 *
 * - Source & Documentation: https://ghe.spotify.net/encore/foundation
 *
 * Tack!
 *
 * Encore
 * encore.spotify.net
 */
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 * Shortest duration.
 */
export var shortest1 = '50ms';
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 * Shortest duration.
 */
export var shortest2 = '100ms';
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 * Shortest duration.
 */
export var shortest3 = '150ms';
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 * Shortest duration.
 */
export var shortest4 = '200ms';
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 * Short duration.
 */
export var short1 = '250ms';
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 * Short duration.
 */
export var short2 = '300ms';
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 * Short duration.
 */
export var short3 = '400ms';
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 * Short duration.
 */
export var short4 = '500ms';
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 * Long duration.
 */
export var long1 = '600ms';
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 * Long duration.
 */
export var long2 = '700ms';
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 * Long duration.
 */
export var long3 = '800ms';
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 * Long duration.
 */
export var long4 = '900ms';
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 * Long duration.
 */
export var long5 = '1000ms';
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 * Longest duration.
 */
export var longest1 = '1100ms';
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 * Longest duration.
 */
export var longest2 = '1200ms';
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 * Longest duration.
 */
export var longest3 = '1300ms';
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 * Longest duration.
 */
export var longest4 = '1400ms';
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 * Longest duration.
 */
export var longest5 = '1500ms';
/**
The default expressive duration for animations.*/
export var expressiveDefaultDuration = short4;
/**
The productive duration for animations.*/
export var expressiveEnterDuration = short3;
/**
The productive duration for animations.*/
export var expressiveExitDuration = shortest4;
/**
The default productive duration for animations.*/
export var productiveDefaultDuration = short2;
/**
The productive duration for animations.*/
export var productiveEnterDuration = short1;
/**
The productive duration for animations.*/
export var productiveExitDuration = shortest4;
